import React from "react";

import {
 
  Crown,
 
  Baby,
  Users,
  
  Tag,
  Layers,
  Star,
  Heart,
  Sun,
  Feather,
  Wind,
  Zap,
  Circle,
  Scissors,
  Droplets,
  Eye,
  Flame,
  Flower2,
  Leaf,
  Moon,
  Palette,
  RefreshCw,
  ShieldCheck,
  Smile,
  Sparkles,
} from "lucide-react";

/* ═══════════════════════════════════════════════════════════
   TYPES
═══════════════════════════════════════════════════════════ */
export interface CategoryItem {
  id: number;
  name: string;
  icon: React.ReactNode;
   image?: any;  
  parentId?: number | null;
  superCategoryId?: number; // 1 = Fashion, 2 = Beauty
}

const sz = 18;


/* ═══════════════════════════════════════════════════════════
   BEAUTY — TOP LEVEL  (superCategoryId: 2)
   Already unified across genders/ages — no separate trees,
   no color/size attribute categories.
═══════════════════════════════════════════════════════════ */
export const BeautyCategories: CategoryItem[] = [
  { id: 201, superCategoryId: 2, name: "Skincare",           icon: <Droplets size={20} />, image: '/icons/beauty/skincare.png' },
  { id: 202, superCategoryId: 2, name: "Makeup",             icon: <Palette size={20} /> },
  { id: 203, superCategoryId: 2, name: "Haircare",           icon: <Wind size={20} /> },
  { id: 204, superCategoryId: 2, name: "Fragrance",          icon: <Flower2 size={20} /> },
  { id: 205, superCategoryId: 2, name: "Body & Bath",        icon: <Sparkles size={20} />, image: '/icons/beauty/bath.png' },
  { id: 206, superCategoryId: 2, name: "Nails",              icon: <Star size={20} /> },
  { id: 207, superCategoryId: 2, name: "Tools & Devices",    icon: <Zap size={20} />, image: '/icons/beauty/tools.png' },
  { id: 209, superCategoryId: 2, name: "Wellness",           icon: <Heart size={20} /> },
  { id: 211, superCategoryId: 2, name: "Beauty Sets & Gifts",icon: <Crown size={20} />, image: '/icons/beauty/gifts.png' },
];


/* Skincare (parentId: 201) */
export const BeautySkincareSubcategories: CategoryItem[] = [
  { id: 20101, parentId: 201, name: "Face",       icon: <Smile size={18} /> },
  { id: 20102, parentId: 201, name: "Eyes",       icon: <Eye size={18} /> },
  { id: 20103, parentId: 201, name: "Lips",       icon: <Heart size={18} /> },
  { id: 20104, parentId: 201, name: "Sun Care",   icon: <Sun size={18} /> },
   
];

export const BeautySkincareFace: CategoryItem[] = [
  { id: 2010101, parentId: 20101, name: "Cleansers & Exfoliators", icon: <Droplets size={16} /> },
  { id: 2010102, parentId: 20101, name: "Toners & Mists",          icon: <Droplets size={16} /> },
  { id: 2010103, parentId: 20101, name: "Serums",                  icon: <Zap size={16} /> },
  { id: 2010104, parentId: 20101, name: "Moisturisers",            icon: <Droplets size={16} /> },
  { id: 2010105, parentId: 20101, name: "Face Oils",                icon: <Droplets size={16} /> },
  { id: 2010106, parentId: 20101, name: "Eye Creams",                icon: <Eye size={16} /> },
  { id: 2010107, parentId: 20101, name: "Face Masks",                icon: <Sparkles size={16} /> },
  { id: 2010108, parentId: 20101, name: "Retinol & Anti-Ageing",     icon: <RefreshCw size={16} /> },
  { id: 2010109, parentId: 20101, name: "Vitamin C",                  icon: <Sun size={16} /> },
  { id: 2010110, parentId: 20101, name: "Acne & Blemish",             icon: <ShieldCheck size={16} /> },
  { id: 2010111, parentId: 20101, name: "Brightening",                icon: <Sparkles size={16} /> },
  { id: 2010112, parentId: 20101, name: "Hyaluronic Acid",            icon: <Droplets size={16} /> },
  { id: 2010113, parentId: 20101, name: "Primers",                    icon: <Layers size={16} /> },
  { id: 2010114, parentId: 20101, name: "BB & CC Creams",             icon: <Layers size={16} /> },
];

export const BeautySunCare: CategoryItem[] = [
  { id: 2010401, parentId: 20104, name: "SPF Face",      icon: <Sun size={16} /> },
  { id: 2010402, parentId: 20104, name: "SPF Body",      icon: <Sun size={16} /> },
  { id: 2010403, parentId: 20104, name: "After Sun",     icon: <Sun size={16} /> },
  { id: 2010404, parentId: 20104, name: "Self-Tan Face", icon: <Sun size={16} /> },
  { id: 2010405, parentId: 20104, name: "Self-Tan Body", icon: <Sun size={16} /> },
  { id: 2010406, parentId: 20104, name: "Tinted SPF",    icon: <Sun size={16} /> },
];

/* Makeup (parentId: 202) */
export const BeautyMakeupSubcategories: CategoryItem[] = [
  { id: 20201, parentId: 202, name: "Face",            icon: <Smile size={18} /> },
  { id: 20202, parentId: 202, name: "Eyes",            icon: <Eye size={18} /> },
  { id: 20203, parentId: 202, name: "Lips",            icon: <Heart size={18} /> },
  { id: 20204, parentId: 202, name: "Nails",           icon: <Star size={18} /> },
  { id: 20205, parentId: 202, name: "Brushes & Tools", icon: <Feather size={18} /> },
];

export const BeautyMakeupFace: CategoryItem[] = [
  { id: 2020101, parentId: 20201, name: "Foundation",           icon: <Layers size={16} /> },
  { id: 2020102, parentId: 20201, name: "Concealer",            icon: <Layers size={16} /> },
  { id: 2020103, parentId: 20201, name: "Blush",                icon: <Circle size={16} /> },
  { id: 2020104, parentId: 20201, name: "Bronzer",               icon: <Sun size={16} /> },
  { id: 2020105, parentId: 20201, name: "Highlighter",           icon: <Sparkles size={16} /> },
  { id: 2020106, parentId: 20201, name: "Contour",                icon: <Layers size={16} /> },
  { id: 2020107, parentId: 20201, name: "Setting Powder & Spray", icon: <Sparkles size={16} /> },
  { id: 2020108, parentId: 20201, name: "Primer",                  icon: <Layers size={16} /> },
  { id: 2020109, parentId: 20201, name: "BB & CC Cream",           icon: <Layers size={16} /> },
];

export const BeautyMakeupEyes: CategoryItem[] = [
  { id: 2020201, parentId: 20202, name: "Mascara",             icon: <Eye size={16} /> },
  { id: 2020202, parentId: 20202, name: "Eyeliner",             icon: <Eye size={16} /> },
  { id: 2020203, parentId: 20202, name: "Eyeshadow & Palettes", icon: <Eye size={16} /> },
  { id: 2020204, parentId: 20202, name: "Eyebrow",               icon: <Feather size={16} /> },
  { id: 2020205, parentId: 20202, name: "False Lashes",          icon: <Eye size={16} /> },
];

export const BeautyMakeupLips: CategoryItem[] = [
  { id: 2020301, parentId: 20203, name: "Lipstick",        icon: <Heart size={16} /> },
  { id: 2020302, parentId: 20203, name: "Lip Gloss",       icon: <Heart size={16} /> },
  { id: 2020303, parentId: 20203, name: "Lip Liner",       icon: <Heart size={16} /> },
  { id: 2020304, parentId: 20203, name: "Liquid Lipstick", icon: <Heart size={16} /> },
];

/* Haircare (parentId: 203) */
export const BeautyHaircareSubcategories: CategoryItem[] = [
  { id: 20301, parentId: 203, name: "Wash & Condition", icon: <Droplets size={18} /> },
  { id: 20302, parentId: 203, name: "Treatments",       icon: <Zap size={18} /> },
  { id: 20303, parentId: 203, name: "Styling",          icon: <Wind size={18} /> },
  { id: 20304, parentId: 203, name: "Hair Colour",      icon: <Palette size={18} /> },
  { id: 20305, parentId: 203, name: "Hair Tools",       icon: <Scissors size={18} /> },
  { id: 20306, parentId: 203, name: "Scalp Care",       icon: <ShieldCheck size={18} /> },
];

export const BeautyHaircareWash: CategoryItem[] = [
  { id: 2030101, parentId: 20301, name: "Shampoo",       icon: <Droplets size={16} /> },
  { id: 2030102, parentId: 20301, name: "Conditioner",   icon: <Droplets size={16} /> },
  { id: 2030103, parentId: 20301, name: "Dry Shampoo",   icon: <Wind size={16} /> },
];

export const BeautyHairTools: CategoryItem[] = [
  { id: 2030501, parentId: 20305, name: "Hair Dryers",           icon: <Wind size={16} /> },
  { id: 2030502, parentId: 20305, name: "Straighteners",         icon: <Zap size={16} /> },
  { id: 2030503, parentId: 20305, name: "Curling Wands & Tongs", icon: <RefreshCw size={16} /> },
  { id: 2030504, parentId: 20305, name: "Hair Clippers",         icon: <Scissors size={16} /> },
  { id: 2030505, parentId: 20305, name: "Brushes & Combs",       icon: <Feather size={16} /> },
];

/* Fragrance (parentId: 204) */
export const BeautyFragranceSubcategories: CategoryItem[] = [
  { id: 20401, parentId: 204, name: "Women's Fragrance", icon: <Flower2 size={18} /> },
  { id: 20402, parentId: 204, name: "Men's Fragrance",   icon: <Flower2 size={18} /> },
  { id: 20403, parentId: 204, name: "Unisex Fragrance",  icon: <Flower2 size={18} /> },
  { id: 20404, parentId: 204, name: "Home Fragrance",    icon: <Flame size={18} /> },
];

export const BeautyHomeFragrance: CategoryItem[] = [
  { id: 2040401, parentId: 20404, name: "Candles",     icon: <Flame size={16} /> },
  { id: 2040402, parentId: 20404, name: "Diffusers",   icon: <Droplets size={16} /> },
  { id: 2040403, parentId: 20404, name: "Room Sprays", icon: <Wind size={16} /> },
];

/* Body & Bath (parentId: 205) */
export const BeautyBodySubcategories: CategoryItem[] = [
  { id: 20501, parentId: 205, name: "Bath & Shower",     icon: <Droplets size={18} /> },
  { id: 20502, parentId: 205, name: "Body Moisturisers", icon: <Sparkles size={18} /> },
  { id: 20503, parentId: 205, name: "Hand Care",         icon: <Sparkles size={18} /> },
  { id: 20504, parentId: 205, name: "Foot Care",         icon: <Leaf size={18} /> },
  { id: 20505, parentId: 205, name: "Deodorant",         icon: <ShieldCheck size={18} /> },
];

/* Nails (parentId: 206) */
export const BeautyNailsSubcategories: CategoryItem[] = [
  { id: 20601, parentId: 206, name: "Nail Polish",     icon: <Star size={18} /> },
  { id: 20602, parentId: 206, name: "Nail Treatments", icon: <Zap size={18} /> },
  { id: 20603, parentId: 206, name: "Nail Tools",      icon: <Scissors size={18} /> },
  { id: 20604, parentId: 206, name: "Gel & UV Nails",  icon: <Sparkles size={18} /> },
  { id: 20605, parentId: 206, name: "Press-On Nails",  icon: <Star size={18} /> },
];

/* Tools & Devices (parentId: 207) */
export const BeautyToolsSubcategories: CategoryItem[] = [
  { id: 20701, parentId: 207, name: "Skincare Devices", icon: <Zap size={18} /> },
  { id: 20702, parentId: 207, name: "Hair Tools",       icon: <Wind size={18} /> },
  { id: 20703, parentId: 207, name: "Makeup Tools",     icon: <Feather size={18} /> },
  { id: 20704, parentId: 207, name: "Nail Tools",       icon: <Scissors size={18} /> },
];

/* Men's Grooming (parentId: 208) */
export const BeautyMensGroomingSubcategories: CategoryItem[] = [
  { id: 20801, parentId: 208, name: "Shaving",    icon: <Scissors size={18} /> },
  { id: 20802, parentId: 208, name: "Beard Care", icon: <Feather size={18} /> },
  { id: 20803, parentId: 208, name: "Face",       icon: <Smile size={18} /> },
  { id: 20804, parentId: 208, name: "Hair",       icon: <Wind size={18} /> },
  { id: 20805, parentId: 208, name: "Body",       icon: <ShieldCheck size={18} /> },
];

/* Wellness (parentId: 209) */
export const BeautyWellnessSubcategories: CategoryItem[] = [
  { id: 20901, parentId: 209, name: "Supplements",     icon: <ShieldCheck size={18} /> },
  { id: 20902, parentId: 209, name: "Sexual Wellness", icon: <Heart size={18} /> },
  { id: 20903, parentId: 209, name: "Aromatherapy",    icon: <Flower2 size={18} /> },
  { id: 20904, parentId: 209, name: "Dental Care",     icon: <Smile size={18} /> },
  { id: 20905, parentId: 209, name: "Eye Care",        icon: <Eye size={18} /> },
  { id: 20906, parentId: 209, name: "Sleep",           icon: <Moon size={18} /> },
];

/* Kids & Baby Beauty (parentId: 210) */
export const BeautyKidsBabySubcategories: CategoryItem[] = [
  { id: 21001, parentId: 210, name: "Baby Skincare",  icon: <Baby size={18} /> },
  { id: 21002, parentId: 210, name: "Baby Bath",      icon: <Droplets size={18} /> },
  { id: 21003, parentId: 210, name: "Baby Haircare",  icon: <Wind size={18} /> },
  { id: 21004, parentId: 210, name: "Kids Skincare",  icon: <Users size={18} /> },
  { id: 21005, parentId: 210, name: "Sun Protection", icon: <Sun size={18} /> },
];

/* Beauty Sets & Gifts (parentId: 211) */
export const BeautySetsSubcategories: CategoryItem[] = [
  { id: 21101, parentId: 211, name: "Skincare Sets",     icon: <Droplets size={18} /> },
  { id: 21102, parentId: 211, name: "Makeup Sets",       icon: <Palette size={18} /> },
  { id: 21103, parentId: 211, name: "Haircare Sets",     icon: <Wind size={18} /> },
  { id: 21104, parentId: 211, name: "Fragrance Sets",    icon: <Flower2 size={18} /> },
  { id: 21105, parentId: 211, name: "Luxury Gift Sets",  icon: <Crown size={18} /> },
  { id: 21106, parentId: 211, name: "Travel Sets",       icon: <Tag size={18} /> },
  { id: 21107, parentId: 211, name: "Discovery Kits",    icon: <Star size={18} /> },
];


export const AllBeautyProducts: CategoryItem[] = [
  ...BeautySkincareFace,
  ...BeautySunCare,
  ...BeautyMakeupFace,
  ...BeautyMakeupEyes,
  ...BeautyMakeupLips,
  ...BeautyHaircareWash,
  ...BeautyHairTools,
  ...BeautyHomeFragrance,
];